import React from 'react';
import { motion } from 'framer-motion';
const pains = ['Llevas noches sin dormir más de dos horas seguidas y ya no sabes cómo vas a aguantar un día más.', 'Tu bebé llora y no sabes qué necesita. Lo has intentado todo y nada funciona.', 'Te preguntas si lo que hace tu bebé es normal para su edad o si deberías preocuparte.', 'Sientes que los demás padres tienen más claro lo que hacen y tú estás improvisando constantemente.', 'La relación con tu pareja está tensa porque los dos estáis agotados y ya no os comunicáis como antes.', 'Tienes miedo de no saber qué hacer si algo va mal y esa incertidumbre te acompaña a todas horas.', 'Sabes que estos meses son importantes pero el agotamiento no te deja disfrutarlos como querrías.'];
export function PainSection() {
  return <section className="bg-white py-[72px] px-5" data-id="element-112">
      <div className="max-w-[820px] mx-auto" data-id="element-113">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} data-id="element-114">
          <span className="text-[0.75rem] tracking-[0.18em] uppercase text-[#8899aa] mb-3 block" data-id="element-115">
            Sabemos exactamente dónde estás
          </span>
          <h2 className="font-serif text-navy mb-5 text-[clamp(1.6rem,3.5vw,2.4rem)]" data-id="element-116">
            ¿Cuántas noches más vas a{' '}
            <em className="not-italic text-gold-dark" data-id="element-117">terminar así?</em>
          </h2>
          <div className="w-12 h-[3px] bg-gold mb-8" data-id="element-118" />

          <p className="mb-5 text-[#2c2c2c]" data-id="element-119">
            No es tu culpa. Nadie te enseña a descifrar el lenguaje de un recién
            nacido. Y sin ese mapa, cada día puede sentirse como improvisar en
            la oscuridad.
          </p>

          <ul className="list-none my-7" data-id="element-120">
            {pains.map((pain, i) => <li key={i} className="py-3.5 pl-9 relative border-b border-[#f0f0f0] text-base text-[#2c2c2c]" data-id="element-121">
                <span className="absolute left-0 top-3.5 text-gold-dark text-[1.1rem]" data-id="element-122">
                  ○
                </span>
                {pain}
              </li>)}
          </ul>

          <div className="text-white py-8 px-9 rounded-[10px] mt-9 text-center" style={{
          background: 'linear-gradient(135deg, #0f1e3d, #1a2f5e)'
        }} data-id="element-123">
            <p className="text-white/90 text-[1.1rem] m-0" data-id="element-124">
              ✦ ¿Y si a partir de hoy tuvieras{' '}
              <strong className="text-gold" data-id="element-125">
                un sistema claro para cada uno de esos momentos?
              </strong>
              <br data-id="element-126" />
              <span className="text-[0.9rem] opacity-80" data-id="element-127">
                Información real. Herramientas concretas. Calma inmediata.
              </span>
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}